// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { SeparateAccountsQuoteModule } from './app.module';
bootstrapAppModule(SeparateAccountsQuoteModule);
